<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="close" max-width="600px">
      <v-card class="background-voucher">
        <v-form v-on:submit.prevent="updateItem">
          <v-card-title class="mb-4">
            <span class="headline" v-if="remito != null && remito.spent != null">Reasignar Gasto</span>
            <span class="headline" v-if="remito != null && remito.spent == null">Asignar Gasto</span>
          </v-card-title>
          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <v-col md="8" class="mt-2">
                  <h6 v-if="remito != null">Remito {{ remito.remito_label }}</h6>
                </v-col>
                <v-col md="8" class="mt-2">
                  <v-combobox
                    :loading="loading_spents"
                    v-model="spent"
                    name="gasto"
                    item-text="voucher_number_label"
                    item-value="id"
                    :items="spents"
                    label="Gasto"
                    autocomplete="off"
                  ></v-combobox>
                  <span class="red--text">{{ errors.first("gasto") }}</span>
                </v-col>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="close()">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading">Editar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { purchaseRemitoService } from "@/libs/ws/purchaseRemitoService";

import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

export default {
  mixins: [ModalGenericMixin],
  components: {},
  props: {
    remito: { type: Object, default: null },
    dialog: Boolean,
    closeDialog: Function,
  },
  data() {
    return {
      spent: null,
      spents: [],
      loading_spents: false,
    };
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.close();
      }
    });
  },
  watch: {
    dialog(val) {
      this.$validator.reset();
      this.errors.clear();

      if (val) {
        this.spent = null;
        this.getSpents();
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    getSpents() {
      this.loading_spents = true;
      let data = {
        supplier_id: this.remito.supplier.id,
      };

      purchaseRemitoService
        .getSpents(data)
        .then((response) => {
          if (response.status) {
            this.spents = response.result;
            this.spents.push(this.remito.spent);
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((response) => {
          this.$toast.error(response.msg, "Error");
        })
        .finally(() => (this.loading_spents = false));
    },
    updateItem(e) {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;

          let data = {
            purchase_remito_id: this.remito.id,
            spent_id: this.spent != null ? this.spent.id : null,
          };

          purchaseRemitoService
            .setSpent(data)
            .then((response) => {
              if (response.status) {
                this.$toast.success("El remito se modifico correctamente", "OK");
                this.close();
                this.$emit("reload");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
